import { combineReducers } from 'redux';

import codeEditorState, { codeEditorInitialState } from './codeEditor.js';
import csvBasicEditorState, { csvBasicEditorInitialState } from './csvBasicEditor.js';
import csvEditorState, { csvEditorInitialState } from './csvEditor.js';
import csvParserState, { csvParserInitialState } from './csvParser.js';
import ftlEditorState, { ftlEditorInitialState } from './ftlEditor.js';
import htmlEditorState, { htmlEditorInitialState } from './htmlEditor.js';
import imagePreviewState, { imagePreviewInitialState } from './imagePreview.js';
import inspectorState, { inspectorInitialState } from './inspector.js';
import ncsvCreatorState, { ncsvCreatorInitialState } from './ncsvCreator.js';
import pdfViewerState, { pdfViewerInitialState } from './pdfViewer.js';
import pythonEditorState, { pythonEditorInitialState } from './pythonEditor.js';
import searchState, { searchlInitialState } from './search.js';
import shareDialogState, { shareDialogInitialState } from './shareDialog.js';

export const toolsInitialState = {
  csvBasicEditorState: csvBasicEditorInitialState,
  csvEditorState: csvEditorInitialState,
  csvParserState: csvParserInitialState,
  ftlEditorState: ftlEditorInitialState,
  htmlEditorState: htmlEditorInitialState,
  imagePreviewState: imagePreviewInitialState,
  inspectorState: inspectorInitialState,
  ncsvCreatorState: ncsvCreatorInitialState,
  pdfViewerState: pdfViewerInitialState,
  codeEditorState: codeEditorInitialState,
  pythonEditorState: pythonEditorInitialState,
  shareDialogState: shareDialogInitialState,
  searchState: searchlInitialState
}
export const toolsState = combineReducers({
  csvBasicEditorState,
  csvEditorState,
  csvParserState,
  ftlEditorState,
  pythonEditorState,
  htmlEditorState,
  imagePreviewState,
  inspectorState,
  ncsvCreatorState,
  pdfViewerState,
  codeEditorState,
  shareDialogState,
  searchState
})